import httpClient from '../../../../utils/httpClient';
import { ApiSuccessResponse } from '../../../../utils/apiSchemas';

export interface NotificationListItem {
  featureType: number;
  notificationType: number;
  messageError?: string;
  stackTrace?: string;
  description?: string;
  statusCode?: number;
  customerName?: string;
  customerGuid?: string;
  success?: boolean;
  resolved?: boolean;
  requestId?: string;
  featureTypeDescription: string;
  notificationTypeDescription: string;
  createdDate: string; // ISO Date string
  createdDateFormatted: string;
}

export type GetNotificationsResponse = NotificationListItem[];

export const getNotifications = async (
  pageNumber: number,
  pageSize: number
): Promise<ApiSuccessResponse<GetNotificationsResponse>> => {
  const response = await httpClient.get<ApiSuccessResponse<GetNotificationsResponse>>(
    `/api/v1/portal/notifications`,
    {
      params: { pageNumber, pageSize }
    }
  );
  return response.data;
};